import React, { useState, useEffect, useRef } from 'react';
import { Button, Modal, Tooltip, OverlayTrigger, } from 'react-bootstrap';
import { Link } from "react-router-dom";
import DatePicker, { DateObject } from "react-multi-date-picker";
import TimePicker from "react-multi-date-picker/plugins/time_picker";
import $ from 'jquery';
import axios from 'axios';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const Followup_Report = ({ show, onClose, data, refresh }) => {

    const baseURL = process.env.REACT_APP_API_BASE_URL;

    // format date display
    const formatDate = (date) => {
        const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
        const d = new Date(date);
        const day = String(d.getDate()).padStart(2, '0');
        const month = months[d.getMonth()];
        const year = d.getFullYear();
        return `${day}-${month}-${year}`;
    };

    function convert24to12(time24) {
        if (time24) {
            const [hourStr, minute, second] = time24.split(':');
            let hour = parseInt(hourStr, 10);

            // Determine AM or PM
            const ampm = hour >= 12 ? 'PM' : 'AM';

            // Convert hour from 24-hour to 12-hour format
            hour = hour % 12;
            if (hour === 0) hour = 12; // the hour '0' should be '12'

            // Return formatted string without seconds (optional)
            return `${hour}:${minute} ${ampm}`;
        } else {
            return '';
        }
    };

    const [reason, setReason] = useState('');


    const [errors, setErrors] = useState({});
    const validate = () => {
        const newErrors = {};
        if (!reason) {
            newErrors.reason = "This Field is Required.";
        }

        return newErrors;
    };

    const user_id = parseInt(localStorage.getItem("user_id"), 10);
    
    const handleSubmit = (event) => {
        event.preventDefault();

        const validationErrors = validate();
        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors);
            return;
        }

        const postData = { 
            reason: reason,
            updated_by: user_id,
        };

        axios.put(`${baseURL}/appointment/cancell/${data.sno}`, postData)
            .then(response => {
                onClose();
                refresh();
                toast.success("Appointment Cancelled Successfully!");
            }).catch(error => {
                onClose();
                console.log(error);
                toast.error("Appointment Cancellation Failed");
            });
    };

    return (

        <Modal show={show} size="lg">
            <div className="modal-content border border-red rounded-xxl">
                <div className="modal-header" style={{ backgroundColor: '#3ab384' }}>
                    <h3 className="modal-title text-white">Appointment Cancelled</h3>
                    <Button variant="" type="button" className="close px-6 py-2" data-dismiss="modal" onClick={onClose}>
                        <span className="text-white">×</span>
                    </Button>
                </div>
                <div className="modal-body">
                    <div className="row">
                        <div className='col-lg-6 col-md-6 col-sm-12 d-flex flex-column mb-2'>
                            <label className='text-gray-800 font-w500 fs-7'>Lead</label>
                            <label className='text-black fs-6 font-w500'>{data.lead_name}</label>
                        </div>
                        <div className='col-lg-6 col-md-6 col-sm-12 d-flex flex-column mb-2'>
                            <label className='text-gray-800 font-w500 fs-7'>Mail ID</label>
                            <label className='text-black fs-6 font-w500'>{data.lead_email ? data.lead_email : '-'}</label>
                        </div>
                        <div className='col-lg-6 col-md-6 col-sm-12 d-flex flex-column mb-2'>
                            <label className='text-gray-800 font-w500 fs-7'>Mobile No</label>
                            <label className='text-black fs-6 font-w500'>{data.lead_mobile}</label>
                        </div>
                        <div className='col-lg-6 col-md-6 col-sm-12 d-flex flex-column mb-2'>
                            <label className='text-gray-800 font-w500 fs-7'>Appointment Date & Time</label>
                            <label className='text-black fs-6 font-w500'>
                                <span className='text-primary'>{formatDate(data.appointment_date)}</span>
                                <span className='me-1 ms-1'>/</span>
                                <span className='text-danger'>{convert24to12(data.appointment_time)}</span>
                            </label>
                        </div>
                        <div className="col-lg-12 mb-2">
                            <div className='row'>
                                <div className="col-lg-12 mt-2 mb-3">
                                    <label className="text-black font-w500 fs-7">Reason<span className="required">*</span></label>
                                    <textarea rows={8} className="form-control" name="comment" placeholder="Reason" 
                                        maxLength={100}
                                        value={reason} 
                                        onChange={(e) => setReason(e.target.value)} 
                                    />
                                    {errors.reason && <div className="text-danger fs-8 mt-1">{errors.reason}</div>}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="d-flex align-items-center justify-content-end gap-3 mt-4 mb-4">
                        <Link type="submit" className="btn btn-sm btn-primary" onClick={handleSubmit} >Appointment Cancelled <i className="fas fa-angle-double-right ms-2"></i></Link>
                    </div>
                </div>
            </div>
        </Modal>
    );
};

export default Followup_Report;
